import { Component, OnInit,Inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ContactUsDialogComponent } from 'src/app/layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Configuration } from 'src/app/models/configurations/configuration';

@Component({
    selector: 'app-verifypopup',
    templateUrl: './verifypopup.component.html',
    styleUrls: ['./verifypopup.component.scss'],
    standalone: false
})
export class VerifypopupComponent implements OnInit {
  tenant: string;
  title: string;
  selection: Configuration;
  onVerifyClickButton = false;
  onApplyClickButton = true;
  dataVerified: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, 
  public matdialogRef: MatDialogRef<VerifypopupComponent>,
  private sideNav: SidenavService, private authService: AuthService) { }

  ngOnInit(): void {
  }
  verifyForm(): void {
    this.matdialogRef.close(true);
    localStorage.setItem('verifyUpdate', this.onVerifyClickButton ? 'true' : 'false');
  }

  verifyFormCancel(): void {
    this.matdialogRef.close(true);
    localStorage.setItem('verifyUpdate', 'close');
  }

  onVerifyClick(): void {
    this.onApplyClickButton = false;
    this.onVerifyClickButton = true;
 }

  onApplyClick(): void {
    this.onApplyClickButton = true;
    this.onVerifyClickButton = false;
  }
}
